export default __webpack_public_path__ + "static/media/ic-faq.11df5404.svg";